import { NumberLiteralType } from "typescript";
import { CommonFunctions } from "../static/common-functions";
import { BaseBus } from "./BaseBus";

export class BuyOutsBus extends BaseBus{
    constructor(busObj: BuyOutsBus){
        super(busObj);
    }
    CID(): any {
        return this.buyoutId;
    }
    setId(id: any) {
        this.buyoutId = id;
    }
    setParentId(id: any) {
        this.bidSheetDetailId = id;
    }
    initialize(data: BuyOutsBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BuyOutsBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    } 
    buyoutId:string;
    bidSheetDetailId:string;
    qty:number;
    btValvesDetails:string;
    btFgPartNo:string;
    inventoryNumber:string;
    bakerAmt:number;
    sellPriceEA:number;
    cost:number;
    sellPrice:number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    inventoryId:string;
    sortOrder  : number;
    public dragging: boolean;
    isFrmTemplate : boolean; 
}